import { useWindowHeight } from "@react-hook/window-size";
import GoogleMapReact from "google-map-react";
import { useContext } from "react";
import { GlobalContext } from "../../App";
import { mapStyles } from "../../lib/mapStyles";

export const MapBase = ({ children }) => {
  const {
    center,
    zoom,
    setZoom,
    setVisibleClinicCardIDs,
    footerHeight,
    isOverlayVisible,
    setIsOverlayVisible,
  } = useContext(GlobalContext);

  const windowHeight = useWindowHeight();

  return (
    <div
      style={{
        height: windowHeight - footerHeight,
        width: "100%",
        position: "relative",
      }}
    >
      {isOverlayVisible && (
        <div
          className="mapOverlay"
          style={{
            background: "rgb(14 43 56 / 90%)",
            position: "absolute",
            top: "0",
            height: "100%",
            width: "100%",
            zIndex: 11,
            display: "flex",
            flexDirection: "column",
            placeContent: "center",
            placeItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setIsOverlayVisible(false)}
        >
          <h2
            style={{
              color: "white",
              textAlign: "center",
            }}
          >
            Find your nearest clinic
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              gap: "10px",
              placeItems: "center",
            }}
          >
            <img
              src="/wp-content/uploads/2021/05/bsf_cursor.svg"
              alt="cursor icon"
              style={{ height: "25px" }}
            />
            <h4
              style={{
                color: "white",
                textAlign: "center",
              }}
            >
              Click/tap to interact with our map
            </h4>
          </div>
        </div>
      )}
      <GoogleMapReact
        bootstrapURLKeys={{
          key: "AIzaSyDxqyg6SaQPv7bwnuL7hj07DC70wA7iwpQ",
          libraries: ["places"],
        }}
        defaultCenter={{
          lat: 55.486477075877474,
          lng: -5.5490673008324904,
        }}
        defaultZoom={6}
        center={center}
        zoom={zoom}
        // yesIWantToUseGoogleMapApiInternals
        options={{
          styles: mapStyles,
          fullscreenControl: false,
          zoomControl: true,
          gestureHandling: "greedy",
        }}
        onClick={(e) => {
          if (!["svg", "path"].includes(e.event.target.localName)) {
            setVisibleClinicCardIDs([]);
          }
        }}
        onZoomAnimationEnd={(e) => {
          setZoom(e);
        }}
      >
        {children}
      </GoogleMapReact>
    </div>
  );
};
